import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_RECORD_BROWSER_ID_TRACKING_072425 } from "@faire/retailer-settings/FE_RECORD_BROWSER_ID_TRACKING_072425";

export const useSettingRecordBrowserIDTracking = () =>
  useSetting(FE_RECORD_BROWSER_ID_TRACKING_072425);
